import React, { useState } from "react";
import { useSnackBar } from "../../../../hooks/useSnackBar";

// components imports
import AttachDocument from "../Components/AttachDocument/AttachDocument";
import AvailableProducts from "./AvailableProducts/AvailableProducts";
import Loader from "../../../../Components/CircularLoader/CircularLoader";
import SelectedProdDetails from "./SelectedProdDetails/SelectedProdDetails";

// apis imports
import { addTransferNote } from "../../../../services/warehouse.services";

// library imports
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Buttons from "@mui/material/Button";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";

const CreateTransferNote = () => {
  const { t } = useTranslation(["inventory", "common"]);
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const setSnack = useSnackBar();
  const [errors, setErrors] = useState({});

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [additionalCost, setAdditionalCost] = useState("0");

  const [formData, setFormData] = useState({
    from_warehouse: "",
    to_warehouse: "",
    status: "",
    media: [],
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const deleteProduct = (rowNumber) => {
    const updatedProducts = selectedProducts.filter(
      (_, index) => index !== rowNumber
    );
    setSelectedProducts(updatedProducts);
  };

  const totalWeight = selectedProducts?.reduce((accumulator, product) => {
    return accumulator + Number(product.weight);
  }, 0);
  const subTotal = selectedProducts?.reduce((accumulator, product) => {
    return accumulator + Number(product.sale_price) * product.quantity;
  }, 0);
  const totalQuantity = selectedProducts?.reduce((accumulator, product) => {
    return accumulator + Number(product.quantity);
  }, 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (selectedProducts.length === 0) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("transferNotes.pleaseSelectAtleastOneProduct"),
          severity: "error",
        };
      });
      setLoading(false);
      return;
    }
    if (formData.from_warehouse === formData.to_warehouse) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("transferNotes.pleaseSelectAlternativeWarehouse"),
          severity: "error",
        };
      });
      setLoading(false);
      return;
    }

    const Formdata = new FormData();
    for (let i = 0; i < formData.media.length; i++) {
      Formdata.append("media[]", formData.media[i]);
    }

    Formdata.append("status", formData.status);

    Formdata.append(
      "transferDetails",
      JSON.stringify(
        selectedProducts?.map((d) => {
          return {
            product_id: d?.product_id,
            quantity: d?.quantity,
          };
        })
      )
    );

    const response = await addTransferNote(
      formData.from_warehouse,
      formData.to_warehouse,
      Formdata
    );
    if (response.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text:
            response?.error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
      setLoading(false);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("transferNotes.transferNoteAddedSuccessfully"),
          severity: "success",
        };
      });
      setLoading(false);
      navigate("/products", { state: { transferId: "transfernote" } });
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="createTransferNote__desc_page">
          <div className="add__prod_sheader hide_mobile_btn">
            <div
              onClick={() =>
                navigate("/products", { state: { transferId: "transfernote" } })
              }
            >
              <BiArrowBack size={22} className="add__prod_sheaderback" />
            </div>
            {t("common:actions.back")}
          </div>
          <h3 className="heading__main_ctn transfer__title_main">
            {t("transferNotes.addTransfer")}
          </h3>

          <div className="form__field_atn_wrap">
            <FormControl
              variant="outlined"
              className="fromWarehouse_field_wrap"
            >
              <InputLabel id="from__warehouse" size="small">
                {t("transferNotes.fromWarehouseRequired")}
              </InputLabel>
              <Select
                required
                labelId="from__warehouse"
                id="from__warehouse"
                size="small"
                // value={formData.from_warehouse}
                label={t("transferNotes.fromWarehouseRequired")}
                name="from_warehouse"
                onChange={handleChange}
              >
                {user?.user_approved_warehouses?.map((warehouse) => (
                  <MenuItem key={warehouse.id} value={warehouse?.warehouse?.id}>
                    {warehouse?.warehouse?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" className="toWarehouse_field_wrap">
              <InputLabel id="to__warehouse" size="small">
                {t("transferNotes.toWarehouseRequired")}
              </InputLabel>
              <Select
                required
                labelId="to__warehouse"
                id="to__warehouse"
                size="small"
                // value={formData.to_warehouse}
                label={t("transferNotes.toWarehouseRequired")}
                onChange={handleChange}
                name="to_warehouse"
              >
                {user?.user_approved_warehouses?.map((warehouse) => (
                  <MenuItem key={warehouse.id} value={warehouse?.warehouse?.id}>
                    {warehouse?.warehouse?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className="warehouse_status_field_wrap"
            >
              <InputLabel id="demo-simple-select-label" size="small">
                {t("transferNotes.selectStatusRequired")}
              </InputLabel>
              <Select
                required
                labelId="demo-simple-select-label"
                id="demo-simple-select-label"
                size="small"
                value={formData?.status || ""}
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: "status",
                      value: e.target.value,
                    },
                  })
                }
                label={t("transferNotes.selectStatus")}
              >
                <MenuItem value="pending">{t("transferNotes.pending")}</MenuItem>
                <MenuItem value="received">{t("transferNotes.received")}</MenuItem>
                <MenuItem value="notReceived">{t("transferNotes.notReceived")}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <AttachDocument
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
          />
          <AvailableProducts
            SelectedProducts={selectedProducts}
            setSelectedProducts={setSelectedProducts}
          />

          <SelectedProdDetails
            SelectedProducts={selectedProducts}
            setSelectedProducts={setSelectedProducts}
            deleteProduct={deleteProduct}
            setAdditionalCost={setAdditionalCost}
            additionalCost={additionalCost}
            totalWeight={totalWeight}
            subTotal={subTotal}
            totalQuantity={totalQuantity}
          />
          <div className="prod__imag_es_modalfooter add_transfer_prod">
            <div
              className="prod__imag_es_modalfootercncl"
              onClick={() => navigate("/products")}
            >
              {t("common:actions.close")}
            </div>
            <Buttons
              type="submit"
              variant="contained"
              size="small"
              style={{ marginLeft: "5px" }}
              disabled={loading ? true : false}
              className="prod__imag_es_modalfootersave"
            >
              {loading ? <Loader /> : t("common:actions.submit")}
            </Buttons>
          </div>
        </div>
      </Form>
    </>
  );
};

export default CreateTransferNote;
